import { useSelector } from "react-redux";
import Loader from "react-loader-spinner";
import React from "react";

const MainLoading = () => {
  const menuInfo = useSelector((state) => state.menuInfo);
  const { loading } = menuInfo;

  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backdropFilter: "blur(5px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          height: "100vh",
          width: "100vw",
          overflow: "hidden",
          zIndex: 10000,
        }}
      >
        <Loader type="Grid" height={70} width={70} color={"#0b9f93"} />
      </div>
    );
  }
  return null;
};

export default MainLoading;
